export default "__VITE_ASSET__7Vj8uwVP__"